import type { Address } from "viem"
import { Config } from "wagmi"

import type { ApiService } from "@/domains/api/api-service"
import type { IEmissionsConfig } from "@/domains/gauge"
import { ScaleApp, ScaleAppContractAddresses } from "@/domains/application/scale"
import { SystemTokenConfig } from "@/domains/tokens/token-repository"

type UseInitializeScaleApplicationProps = {
  apiService: ApiService
  safeAddress: Address
  chainSlug: string
  scaleAppContractAddresses: ScaleAppContractAddresses
  config: Config
  chainId: number
  systemTokenAddresses: SystemTokenConfig
  routerAddress: Address
  emissionsConfig: IEmissionsConfig
}

export const useInitializeScaleApplication = (props: UseInitializeScaleApplicationProps): ScaleApp | undefined => {
  return ScaleApp.initialize(props)
}
